import React from "react";
import Modal from "react-modal";
import { HiX } from "react-icons/hi";

Modal.setAppElement("#root");

type PROPS = {
  modalIsOpen: boolean;
  action?: (result: boolean) => void;
};

const NoteTransactionsDialog: React.FC<PROPS> = (props) => {
  const modalStyle: Modal.Styles = {
    overlay: {
      backgroundColor: "rgba(0,0,0,0.60)",
      zIndex: 10000,
    },
    content: {
      right: "unset",
      bottom: "unset",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      padding: "16px",
      borderRadius: "30px",
      border: "4px solid rgb(24, 10, 131)",
    },
  };

  const close = (result = false) => {
    if (props.action) {
      props.action(result);
    }
  };

  return (
    <Modal isOpen={props.modalIsOpen} onRequestClose={() => close()} style={modalStyle}>
      <div className="flex justify-between items-center gap-4 mb-5">
        <div></div>
        <div className="font-bold text-xl text-center text-red-500 border-b border-red-500">※取引上の注意事項</div>
        <div className="p-1 rounded cursor-pointer hover:bg-gray-300" onClick={() => close()}>
          <HiX />
        </div>
      </div>
      <div className="p-2">
        本プラットホーム上で行う取引においては、許認可が必要な業種
        <br />
        の商材や第三者の知的財産に関する権利等（出願中のものを含む）を
        <br />
        侵害する違法な取引ではないことを確認しました。
      </div>
    </Modal>
  );
};

export default NoteTransactionsDialog;
